module.exports = __webpack_public_path__ + "static/media/todolist2.4f7c2bf9.png";